module.exports = __webpack_public_path__ + "static/media/logo.e1ca68d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/logo.svg
// module id = 127
// module chunks = 0